const invitesModule = {
  //  Easy VUEX firestore configuration
  firestorePath: 'invites',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'invites',
  statePropName: 'invitesData',
  namespaced: true,
  state: {},
  getters: {
    workspaceInvites: (state, getters, rootState, rootGetters) => {
      return Object.values(state.invitesData).filter(i => i.status == 'open');
    },
  },
  mutations: {},
  actions: {
    subscribeToInvites({ dispatch, rootGetters }, { workspaceId }) {
      return new Promise((resolve, reject) => {
        //get userId and throw an error if there are any problems getting the user ID
        if (!rootGetters['auth/isUser']) {
          reject('auth/isUser is set to false');
        }
        console.log(workspaceId);
        dispatch('openDBChannel', {
          where: [
            ['workspace.id', '==', workspaceId],
            ['status', '==', 'open']
          ]
        })
          .then(() => {
            console.log('subscribed to workspace invites');
            resolve('subscribed');
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    unsubscribeToInvites({ dispatch }) {
      console.log('unsubscribe for invites');
      dispatch('closeDBChannel', { clearModule: true });
    },
    async addInviteDoc({ dispatch, rootGetters }, { email, workspace }) {
      const userId = rootGetters['auth/userId'];
      const invite = {
        createdOn: new Date(),
        createdBy: userId,
        toEmail: email,
        workspace,
        status: 'open' // open, accepted, denied, canceled, expired
      };
      const id = await dispatch('insert', invite);
      console.log(id);
      return id;
    },
    changeStatus({ dispatch }, { inviteId, status }) {
      dispatch('patch', { id: inviteId, status: status });
    }
  }
};

export default invitesModule;
